"use strict";
// ***
// Types and validation logic for communication with the Lead API
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadApiMethodOption = void 0;
var LeadApiMethodOption;
(function (LeadApiMethodOption) {
    LeadApiMethodOption["abroadLegacy"] = "abroad";
    LeadApiMethodOption["onlineLegacy"] = "online";
    LeadApiMethodOption["abroad"] = "I want to study abroad";
    LeadApiMethodOption["online"] = "I want to study online";
    LeadApiMethodOption["both"] = "both";
    LeadApiMethodOption["none"] = "none";
})(LeadApiMethodOption || (LeadApiMethodOption = {}));
exports.LeadApiMethodOption = LeadApiMethodOption;
